type MyAccountInputProps = {
  title: string;
  value: string | null;
};

export const MyAccountDisplayText = ({ title, value }: MyAccountInputProps) => {
  return (
    <div className="flex flex-col items-start border-b border-b-line py-4 sm:flex-row sm:items-center sm:py-2">
      <div className="w-[200px] font-semibold">{title}</div>
      <p className="grow">{value}</p>
    </div>
  );
};
